/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Main 'Add to cart' (ATC) form
*/
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.btn-atc')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    form.classList.add('loading')

    const isAprilFools = form.querySelector('input[name=april-fools][value=true]')
    if (isAprilFools) {
      event.stopImmediatePropagation()
      window.location.href = '/discount/FOOLEDYA?redirect=/pages/april-fools-offers'
      return
    }

    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    form.classList.remove('loading')
    btn.innerHTML = window.theme.product.addedToCart

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textAddToCart
    }, 2000)

    window.refreshCartContents(response)

    if (btn.closest('.modal')) return

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }
}

/*
    Product options selector - Listen for change events
*/
window.onChangeProductOption = async (input) => {
    const selectedOptions = []

    input.closest('form').querySelectorAll('.product-option').forEach(elem => {
        if (elem.type === 'radio') {
            if (elem.checked) {
                selectedOptions.push(elem.value)
            }
        } else {
            selectedOptions.push(elem.value)
        }
    })

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    const btn = input.closest('form').querySelector('.btn-atc')

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
        }

        let price = selectedVariant.price
        let compareAtPrice = selectedVariant.compare_at_price
        const subscriptionSelected = !!document.querySelector('#purchase-options-subscription:checked')
        if (subscriptionSelected) {
          compareAtPrice = selectedVariant.price
          price = selectedVariant.selling_plan_allocations[0].price
        }

        if (compareAtPrice) {
            input.closest('.product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-compare text-muted me-3">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(compareAtPrice)}
                    </s>
                </span>
                <span class="product-price-final">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(price)}
                </span>
                <span class="product-item-price-pack opacity-50 fs-6 ms-2" ${selectedVariant.title.includes('Pack') ? '' : 'hidden'}>
                    /${selectedVariant.title}
                </span>
            `
        } else {
            input.closest('.product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-final">
                    ${Shopify.formatMoney(price)}
                </span>
                <span class="product-item-price-pack opacity-50 fs-6 ms-2" ${selectedVariant.title.includes('Pack') ? '' : 'hidden'}>
                    /${selectedVariant.title}
                </span>
            `
        }

        const purchaseOptionsWrapper = document.querySelector('#product-purchase-options')

        if (purchaseOptionsWrapper) {
            purchaseOptionsWrapper.querySelector('#product-options-onetime-wrapper [data-price]').textContent = Shopify.formatMoney(selectedVariant.price)
            purchaseOptionsWrapper.querySelector('#product-options-subscription-wrapper .subscription-price-compare').textContent = Shopify.formatMoney(selectedVariant.price)
            purchaseOptionsWrapper.querySelector('#product-options-subscription-wrapper [data-price]').textContent = Shopify.formatMoney(selectedVariant.selling_plan_allocations[0].price)
        }

        if (input.closest('#product-template')) {
            const url = new URL(window.location)
            url.searchParams.set('variant', selectedVariant.id)
            window.history.replaceState({}, '', url)
        }

        const customEvent = new CustomEvent('variantChange.ecomify.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }

    if (input.closest('.color-swatches')) {
        input.closest('.product-option-wrapper').querySelector('.color-swatches-title span:last-of-type')
            .textContent = input.value
    }

    if (input.closest('.size-buttons')) {
        input.closest('.product-option-wrapper').querySelector('.size-buttons-title span:last-of-type')
            .textContent = input.value
    }
}

/*
    Update various elements on variant change that need a new document fetch
*/
// window.addEventListener('variantChange.ecomify.product', async (event) => {
//     const inventoryBar = document.querySelector('#inventory-bar')

//     if (inventoryBar) {
//         inventoryBar.style.opacity = '.25'
//     }

//     const respoonse = await fetch(window.location.href)
//     const text = await respoonse.text()
//     const newDocument = new DOMParser().parseFromString(text, 'text/html')

//     document.querySelector('#inventory-bar')
//         ?.replaceWith(newDocument.querySelector('#inventory-bar'))
// })

/*
    Purchase options (selling/subscription plans)
*/
const initPurchaseOptions = () => {
    const wrapper = document.querySelector('#product-purchase-options')

    if (!wrapper) return

    wrapper.querySelectorAll('[name="purchase_option"]').forEach(input => {
        input.addEventListener('change', () => {
            if (input.id === 'purchase-options-one-time') {
                wrapper.querySelector('#purchase-delivery-options').setAttribute('hidden', 'hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = true
                document.querySelectorAll('#product-content [data-pack-price]').forEach(elem => {
                    elem.textContent = `${Shopify.formatMoney(elem.dataset.packPrice)} per bar`
                })
                wrapper.querySelector('[data-purchase-option-title-helper]').textContent = wrapper.querySelector('[data-purchase-option-title-helper]').dataset.textOneTime
            } else {
                wrapper.querySelector('#purchase-delivery-options').removeAttribute('hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = false
                document.querySelectorAll('#product-content [data-pack-price]').forEach(elem => {
                    elem.textContent = `${Shopify.formatMoney(elem.dataset.packPriceSub)} per bar`
                })
                wrapper.querySelector('[data-purchase-option-title-helper]').textContent = wrapper.querySelector('[data-purchase-option-title-helper]').dataset.textSubscription
            }
          window.onChangeProductOption(input)
        })
    })
}
initPurchaseOptions()

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

/*
    Product Gallery
*/
const initProductGallery = () => {
    document.querySelectorAll('.product-gallery:not(.init)').forEach(gallery => {
        gallery.classList.add('init')

        const main = new Splide(gallery.querySelector('.main-splide'), {
            start: Number(gallery.dataset.start),
            rewind: true,
            arrows: false,
            rewindByDrag: true,
            pagination: false,
            noDrag: 'model-viewer',
            mediaQuery: 'min',
            breakpoints: {
                0: { padding: 0 },
                992: { padding: 0 }
            }
        })

        const totalSlides = gallery.querySelectorAll('.main-splide .splide__slide').length

        const thumbs = new Splide(gallery.querySelector('.thumbs-splide'), {
            start: Number(gallery.dataset.start),
            gap: '.5rem',
            rewind: true,
            rewindByDrag: true,
            pagination: false,
            isNavigation: true,
            focus: totalSlides > 5 ? 'center' : 0,
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: 5, arrows: true },
                576: { perPage: 5, arrows: true },
                768: { perPage: 5, arrows: true },
                992: { perPage: 5, arrows: true },
                1200: { perPage: 5, arrows: true },
                1400: { perPage: 5, arrows: true }
            }
        })

        main.on('move', (newIndex, prevIndex) => {
            const iframe = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) iframe`)
            const video = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) video`)
            if (iframe) {
                // eslint-disable-next-line no-self-assign
                iframe.src = iframe.src
            }
            if (video) {
                video.pause()
            }
        })

        window.addEventListener('variantChange.ecomify.product', (event) => {
            const selectedVariant = event.detail

            if (selectedVariant.featured_media) {
                main.go(selectedVariant.featured_media.position - 1)
            }
        }, false)

        main.sync(thumbs)
        main.mount()
        thumbs.mount()

        if (window.matchMedia('(min-width: 992px)').matches) {
            const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
            const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0
            gallery.style.position = 'sticky'
            gallery.style.top = `${navbarHeight + announcementBarHeight + 20}px`
            gallery.style.zIndex = '1'
        }

        const modelViewer = gallery.querySelector('model-viewer')

        if (modelViewer) {
            const increaseBtn = gallery.querySelector('[data-model-3d-increase-zoom]')
            const decreaseBtn = gallery.querySelector('[data-model-3d-decrease-zoom]')
            const fullscreenBtn = gallery.querySelector('[data-model-3d-fullscreen]')

            increaseBtn.addEventListener('click', () => {
                modelViewer.zoom(1)
            })

            decreaseBtn.addEventListener('click', () => {
                modelViewer.zoom(-1)
            })

            fullscreenBtn.addEventListener('click', () => {
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').removeAttribute('hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').setAttribute('hidden', 'hidden')
                } else {
                    modelViewer.closest('.product-gallery-model-3d').requestFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').setAttribute('hidden', 'hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').removeAttribute('hidden')
                }
            })
        }
    })
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-gallery')) {
        initProductGallery()
    }
})

window.addEventListener('updated.ecomify.collection', initProductGallery)

// Product forms in product list items
window.onChangeProductItemVariant = (select, event) => {
    const selectedOption = select.options[select.selectedIndex]

    if (selectedOption.dataset.compareAtPrice.length) {
        select.closest('.product-item').querySelector('.product-item-price-compare').textContent = Shopify.formatMoney(selectedOption.dataset.compareAtPrice)
        select.closest('.product-item').querySelector('.product-item-price-compare').removeAttribute('hidden')
    }

    select.closest('.product-item').querySelector('.product-item-price-final').textContent = Shopify.formatMoney(selectedOption.dataset.price)
    select.closest('.product-item').querySelector('.product-item-price-final').setAttribute('data-price', selectedOption.dataset.price)
    select.closest('.product-item').querySelector('.product-item-price-pack').textContent = `/${selectedOption.textContent}`
}

// Product forms in product list items
window.onChangeProductItemFrequency = (select, event) => {
    const priceFinalEl = select.closest('.product-item').querySelector('.product-item-price-final')

    if (select.value === 'once') {
        select.name = ''
        priceFinalEl.textContent = Shopify.formatMoney(priceFinalEl.dataset.price)
    } else {
        select.name = 'selling_plan'
        priceFinalEl.textContent = Shopify.formatMoney(priceFinalEl.dataset.price * 0.8)
    }
}

/*
    Recently viewed
*/
const initRecentlyViewed = async () => {
    const localStorageKey = 'recently_viewed_v1'

    if (document.body.classList.contains('page-type-product')) {
        const productHandle = document.querySelector('#product-template').dataset.productHandle

        const response = await fetch(`${productHandle}.js`)
        const product = await response.json()
        // console.log(product)

        let recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || []
        const isViewed = recentlyViewed.some((elem) => elem.handle === product.handle)

        if (isViewed) {
            recentlyViewed = recentlyViewed.filter(elem => elem.handle !== product.handle)
        }

        recentlyViewed.unshift({
            id: product.id,
            handle: product.handle,
            url: product.url,
            title: product.title,
            compare_at_price: product.compare_at_price,
            price: product.price,
            price_varies: product.price_varies,
            featured_image: product.featured_image,
            vendor: product.vendor,
            time: Date.now()
        })

        if (recentlyViewed.length > 50) {
            recentlyViewed.pop()
        }

        localStorage.setItem(localStorageKey, JSON.stringify(recentlyViewed))
    }
}
initRecentlyViewed()


document.querySelector('#product-options-onetime-wrapper')?.addEventListener('click', function () {
  document.querySelector('#product-options-onetime-wrapper label').click();
})

document.querySelector('#product-options-subscription-wrapper')?.addEventListener('click', function (ev) {
  if (ev.target.tagName === 'SELECT') return
  document.querySelector('#product-options-subscription-wrapper label').click();
})
